export const SITE_ORIGIN =
  (typeof process.env.REACT_APP_SITE_ORIGIN === "string" &&
    process.env.REACT_APP_SITE_ORIGIN.trim().replace(/\/$/, "")) ||
  "https://flexlearnai.com";

export const ORGANIZATION = {
  "@type": "Organization",
  "@id": `${SITE_ORIGIN}/#organization`,
  name: "FlexLearnAI",
  url: SITE_ORIGIN,
  legalName: "FlexLabs LLC",
  logo: { "@type": "ImageObject", url: `${SITE_ORIGIN}/logo-small-1024.png` },
  sameAs: [
    "https://www.tiktok.com/@flexlearnai",
    "https://www.instagram.com/flexlearnai8",
    "https://www.youtube.com/@FlexLearnAI",
    "https://www.facebook.com/people/FlexLearnai/61589708818075/",
    "https://discord.gg/tEwkkM4Q43",
  ],
};

const WEBSITE = {
  "@type": "WebSite",
  "@id": `${SITE_ORIGIN}/#website`,
  name: "FlexLearnAI",
  url: SITE_ORIGIN,
  publisher: { "@id": `${SITE_ORIGIN}/#organization` },
};

const SOFTWARE_APPLICATION = {
  "@type": "SoftwareApplication",
  name: "FlexLearnAI",
  applicationCategory: "EducationalApplication",
  operatingSystem: "Web, iOS, Android",
  url: SITE_ORIGIN,
  description:
    "FlexLearnAI is an AI study coach that turns your own notes, PDFs, and textbooks into personalized practice questions and a study plan that adapts to your level.",
  offers: { "@type": "Offer", price: "0", priceCurrency: "USD" },
  publisher: { "@id": `${SITE_ORIGIN}/#organization` },
};

/** Build a FAQPage node from [{ question, answer }]. */
export function faqSchema(items) {
  if (!items?.length) return null;
  return {
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer },
    })),
  };
}

/** Build a BreadcrumbList from [{ name, path }]. */
export function breadcrumbSchema(crumbs) {
  if (!crumbs?.length) return null;
  return {
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((crumb, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: crumb.name,
      item: `${SITE_ORIGIN}${crumb.path}${crumb.path.endsWith("/") ? "" : "/"}`,
    })),
  };
}

/**
 * Baseline @graph for a standalone page: Organization + BreadcrumbList.
 *
 * Hub and article pages build richer graphs of their own (ItemList, Article,
 * LearningResource). This is for the pages that had no structured data at all —
 * legal, about, contact, pricing — so every crawlable URL carries at least its
 * publisher and its place in the site hierarchy.
 */
export function pageGraph(crumbs) {
  return {
    "@context": "https://schema.org",
    "@graph": [ORGANIZATION, breadcrumbSchema(crumbs)].filter(Boolean),
  };
}

/** Site-wide @graph for the homepage: Organization + WebSite + SoftwareApplication (+ optional FAQ). */
export function homeGraph(faqItems) {
  /** @type {object[]} */
  const graph = [ORGANIZATION, WEBSITE, SOFTWARE_APPLICATION];
  const faq = faqSchema(faqItems);
  if (faq) graph.push(faq);
  return { "@context": "https://schema.org", "@graph": graph };
}
